<script setup>
import { ref } from 'vue'
import VideoGalleryItem from './VideoGalleryItem.vue'

const props = defineProps({
  title: {
    type: String,
    default: 'Заголовок',
  },
  subtitle: {
    type: String,
    default: 'Подзаголовок',
  },
  videos: {
    type: Array,
    default: () => [],
  },
})

const isOpen = ref(false)

const toggleOptions = () => {
  isOpen.value = !isOpen.value
}
</script>

<template>
  <section class="dropdown-gallery">
    <h2 class="section-subtitle" @click="toggleOptions">
      {{ title }}
      <span class="plus-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          :class="{ rotate: isOpen }"
        >
          <rect
            class="horizontal"
            x="4"
            y="11"
            width="16"
            height="2"
            :class="{ 'fade-out': isOpen }"
            fill="#000"
          />
          <rect class="vertical" x="11" y="4" width="2" height="16" fill="#000" />
        </svg>
      </span>
    </h2>
    <p v-if="subtitle" class="section-subtitle-text">{{ subtitle }}</p>
    <div :class="{ 'gallery-container': true, open: isOpen }">
      <VideoGalleryItem
        v-for="video in videos"
        :key="video.videoSrc"
        :video-src="video.videoSrc"
        :poster-src="video.posterSrc"
        :title="video.title"
      />
    </div>
  </section>
</template>

<style scoped>
.dropdown-gallery {
  padding-bottom: 0rem;
  margin: 0 auto;
  max-width: 90rem;
}

.section-subtitle {
  display: flex;
  align-items: center;
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 0rem;
  text-align: left;
  color: var(--color-black);
  text-transform: uppercase;
  cursor: pointer;
  user-select: none;
}

.section-subtitle-text {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 2.5rem;
  text-align: left;
  color: var(--color-black);
  line-height: 1.5;
}

.gallery-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition:
    max-height 0.5s ease,
    opacity 0.5s ease;
}

.gallery-container.open {
  max-height: 62.5rem;
  opacity: 1;
}

@media (min-width: 769px) and (max-width: 1024px) {
  .gallery-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;
  }

  .section-subtitle {
    font-size: 24px;
  }
}

@media (min-width: 1025px) and (max-width: 1280px) {
  .gallery-container {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
  }

  .section-subtitle {
    font-size: 25px;
  }
}

.gallery-item {
  border-radius: 0.25rem;
  background: var(--color-bg-darkest);
  padding: 1rem;
  border: none;
  color: var(--color-white);
  text-align: center;
}

.gallery-item:nth-child(2n) {
  background: none;
}

.gallery-image {
  width: 100%;
  height: auto;
  border-radius: 0.25rem;
  margin-bottom: 0.5rem;
}

.image-title {
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.045rem;
  text-transform: uppercase;
  margin-top: 0.5rem;
}

.plus-icon {
  margin-left: 0.625rem;
  transition: opacity 0.3s ease;
  transform-origin: center;
  margin-top: 0.313rem;
}

.plus-icon svg {
  transition: transform 0.3s ease;
}

.plus-icon svg.rotate {
  animation: rotate-animation 0.3s forwards;
}

@keyframes rotate-animation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(90deg);
  }
}

.horizontal {
  transition: opacity 0.3s ease;
}

.horizontal.fade-out {
  opacity: 0;
}

@media (max-width: 768px) {
  .dropdown-gallery {
    padding-bottom: 1rem;
  }

  .gallery-container {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}
</style>
